import React, { useState, useEffect } from "react";
import axios from "axios";
import { MdMan, MdWoman } from "react-icons/md";
import "./home.css";
import "./responsive.css";
// import Select from "react-select";
import { Button, Modal } from "react-bootstrap";
import NoDataImage from "../../background.gif";
import { Link } from "react-router-dom";

export default function Bnner() {
  // for form caste
  // caste data
  const [casteOptions, setCasteOptions] = useState([]);

  // for form caste

  //  bg image
  const [bgImage, setBgImage] = useState(null);
  const [imageLoadError, setImageLoadError] = useState(false);

  const [formData, setFormData] = useState({
    gender: "male",
    // lookingFor: "female",
    religion: "Hindu",
    caste: "Select Caste",
    minAge: 21,
    maxAge: 60,
  });

  const [apiData, setApiData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isOpenModal, setOpenModal] = useState(false);

  const handleModal = () => {
    setOpenModal(!isOpenModal);
  }


  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_API_BASE_URL}admin-mat/api/caste.php`
      )
      .then((response) => {
        if (Array.isArray(response.data.data.caste)) {
          setCasteOptions(response.data.data.caste);
        } else {
          console.error("Unexpected caste data format:", response.data);
          setCasteOptions([]);
        }


      })
      .catch((error) => {
        console.error("Error fetching caste data:", error);
      });

    axios
      .get(
        `${process.env.REACT_APP_API_BASE_URL}admin-mat/api/banner-image.php`
      )
      .then((response) => {
        if (response.data.banner_image) {
          // Verify the image exists before setting it
          const img = new Image();
          img.onload = () => {
            setBgImage(response.data.banner_image);
            setImageLoadError(false);
          };
          img.onerror = () => {
            console.error("Image failed to load:", response.data.banner_image);
            setImageLoadError(true);
          };
          img.src = response.data.banner_image;
        }
        const imageURL = process.env.REACT_APP_API_BASE_URL + response.data.banner_image;
        setBgImage(imageURL);
      })
      .catch((error) => {
        console.error("API Error:", error);
        setImageLoadError(true);
      });
    setIsLoading(false);
  }, [formData, apiData]);

  //  bg image

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleAgeChange = (e, type) => {
    const value = parseInt(e.target.value);
    if (type === "min") {
      setFormData((prev) => ({
        ...prev,
        minAge: Math.min(value, prev.minAge),
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        maxAge: Math.max(value, prev.minAge),
      }));
    }
  };

  // Calculate age from DOB
  const calculateAge = (dob) => {
    if (!dob) return "N/A";
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  };

  // Format height (5.6 => 5'6")
  const formatHeight = (height) => {
    if (!height) return "N/A";
    const [feet, inches] = height.split(".");
    return `${feet}'${inches}"`;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);


    const payload = new FormData();
    payload.append("gender", formData.gender);
    payload.append("age", formData.maxAge);
    payload.append("caste", formData.caste);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}mycon/recently_joint_search`, payload
      );
      if (response.data.users) setApiData(response.data);
      // else setApiData({});
      handleModal();
    } catch (error) {
      console.error("There was an error fetching users!", error);
    } finally {
      setLoading(false);
    }
    setLoading(false);

  };


  return (

    <>
      {isLoading && <div className='custom-loader-g'>
        <div class="spinner-border text-danger" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>}


      <div>
        <section className="bg-img">
          <div className="str">
            <div
              className="hom-head"
              style={{
                backgroundImage: `url('${bgImage}')`,
                height: "700px",
                backgroundSize: "cover",
                backgroundPosition: "top",
                backgroundColor: "#f5f5f5", // Fallback color
                backgroundRepeat: "no-repeat",
                position: "relative", // For overlay content
              }}
            >
              {/* Dark overlay for better text visibility */}
              {/* {bgImage && !imageLoadError && ( */}
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: "rgba(0,0,0,.1)",
                 
                }}
              ></div>
              {/* )} */}

              <div
                className="container"
                style={{ position: "relative", zIndex: 1 }}
              >
                <div className="row">
                  <div className="hom-ban">
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6">
                        <div className="banner-content">
                          <h1 style={{ textShadow:"#000 1px 0 10px"}} className="text-white fw-bold">
                            Your Journey To Love Begins{" "}
                            <span style={{ textShadow:"#fff 1px 0 10px",color: "#F4B818",fontWeight:"bold" }}>here !</span>
                          </h1>

                          <h3 className="text-white fw-bold" style={{textShadow:"#000 1px 0 10px"}}>
                            Connect With Genuine Matches Who <br /> Share Your{" "}
                            <span style={{ textShadow:"#fff 1px 0 10px",color: "#F4B818",fontWeight:"bold" }}>values</span> and{" "}
                            <span style={{ textShadow:"#fff 1px 0 10px",color: "#F4B818",fontWeight:"bold" }}>dreams.</span>
                          </h3>

                          {apiData.users && (
                            <div
                              className="api-response"
                              style={{
                                marginTop: "20px",
                                padding: "10px",
                                backgroundColor: "rgba(255,255,255,0.2)",
                                borderRadius: "5px",
                              }}
                            >
                              <p className="mb-0 alert alert-danger" style={{ color: 'rgb(255, 255, 255)', background: '#e53d5c' }}>
                                Success! {apiData.message}
                              </p>
                            </div>
                          )}

                          {error && (
                            <div
                              className="error-message"
                              style={{
                                marginTop: "20px",
                                padding: "10px",
                                backgroundColor: "rgba(255,0,0,0.2)",
                                borderRadius: "5px",
                              }}
                            >
                              <p style={{ color: "#fff" }}>Error: {error}</p>
                            </div>
                          )}

                          {/* Image load error message (debugging only) */}
                          {imageLoadError && (
                            <div style={{ color: "black", marginTop: "10px" }}>
                              {/* Banner image failed to load/ */}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6">
                        <div className="wedding-form-container">
                          <div className="wedding-form">
                            <form onSubmit={handleSubmit}>
                              {/* Form sections remain exactly the same */}
                              {/* I'm A section */}
                              <div className="form-section">
                                <label className="form-label">I'm</label>
                                <div className="gender-options">
                                  <label
                                    className={`gender-option ${formData.gender === "male" ? "selected" : ""
                                      }`}
                                  >
                                    <input
                                      type="radio"
                                      name="gender"
                                      value="male"
                                      checked={formData.gender === "male"}
                                      onChange={handleChange}
                                      className="hidden-radio"
                                    />
                                    <MdMan className="gender-icon" /> Male
                                  </label>
                                  <label
                                    className={`gender-option ${formData.gender === "female"
                                      ? "selected"
                                      : ""
                                      }`}
                                  >
                                    <input
                                      type="radio"
                                      name="gender"
                                      value="female"
                                      checked={formData.gender === "female"}
                                      onChange={handleChange}
                                      className="hidden-radio"
                                    />
                                    <MdWoman className="gender-icon" /> Female
                                  </label>
                                </div>
                              </div>



                              {/* Religion and Caste */}
                              <div className="form-row">
                                <div className="form-section" style={{ width: "50%" }}>
                                  <label className="form-label">Religion</label>
                                  <select
                                    name="religion"
                                    value={formData.religion}
                                    onChange={handleChange}
                                    className={`form-select ${formData.religion ? "selected" : ""
                                      }`}
                                  >
                                    <option value="">Select Religion</option>
                                    <option value="Hindu">Hindu</option>
                                  </select>
                                </div>
                                <div className="form-section" style={{ width: "49%" }}>
                                  <label className="form-label">Caste</label>
                                  <select required
                                    name="caste"
                                    value={formData.caste}
                                    onChange={handleChange}
                                    className={`form-select ${formData.caste &&
                                      formData.caste !== "Select Caste"
                                      ? "selected"
                                      : ""
                                      }`}
                                  >
                                    <option value="">Select Caste</option>
                                    {casteOptions.map((caste, index) => (
                                      <option key={index} value={caste}>
                                        {caste}
                                      </option>
                                    ))}
                                  </select>
                                  {/* <Select
                                  options={casteOptions.map((caste) => ({ label: caste, value: caste }))}
                                  value={formData.caste}
                                  onChange={(selected) => handleChange({ target: { name: "caste", value: selected } })}
                                /> */}
                                </div>
                              </div>

                              {/* Age Range */}
                              <div className="form-section">
                                <label className="form-label">
                                  Of Age Around
                                </label>
                                <div className="age-display">
                                  <span>{formData.minAge}</span>
                                  <span>{formData.maxAge}</span>
                                </div>
                                <div className="age-slider-container">
                                  {/* <div className="age-slider-track">
                                  <div
                                    className="age-slider-range"
                                    style={{
                                      left: `${((formData.minAge - 20) / 50) * 100
                                        }%`,
                                      right: `${80 -
                                        ((formData.maxAge - 20) / 50) * 100
                                        }%`,
                                    }}
                                  ></div> 
                                </div> */}
                                  <input
                                    type="range"
                                    min="21"
                                    max="21"
                                    value={formData.minAge}
                                    onChange={(e) => handleAgeChange(e, "min")}
                                    className="age-slider min-slider"
                                  />
                                  <input
                                    type="range"
                                    min="30"
                                    max="60"
                                    step={5}
                                    value={formData.maxAge}
                                    onChange={(e) => handleAgeChange(e, "max")}
                                    className="age-slider max-slider"
                                  />
                                </div>
                                <div className="age-marks">
                                  <span>21</span>
                                  <span>30</span>
                                  <span>40</span>
                                  <span>50</span>
                                  <span>60</span>
                                </div>
                              </div>

                              <button
                                type="submit"
                                className="submit-button"
                                disabled={loading}
                              >
                                {loading
                                  ? "Searching..."
                                  : "Start Your Search Today!"}
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>







      <Modal backdrop="static" aria-labelledby="contained-modal-title-vcenter"
        centered keyboard={false} show={isOpenModal} size="xl" onHide={handleModal}>
        <Modal.Body >

          <div className="row">




            {(!apiData.users) ? (<div className='position-relative nodataBox w-100 h-100' style={{ backgroundImage: `url(${NoDataImage})` }}><div><h2 className={'text-white fw-bold text-center'}>No Match Found</h2>
              <Button onClick={handleModal} className="btn btn-light mx-auto d-block">Search Again</Button>
            </div>

            </div>) : ""}

            {(apiData?.users) ? apiData?.users?.map(member => (
              <Link  to={`/login`} key={member.user_id} className="col-md-4 my-2">
                <div className="overflow-hidden" style={{ borderRadius: "10px" }}>
                  <img
                    src={
                      member.image1
                        ? `${process.env.REACT_APP_API_BASE_URL}${member.image1}`
                        : "/default.jpg"
                    }
                    alt={member.name}
                    onError={(e) => {
                      e.target.src = "/default.jpg";
                      e.target.onerror = null;
                    }}
                    className="member-image"
                  />
                  <div className="member-info">
                    <h5> {member.name}</h5>
                    <div className="member-id-gender">
                      <span className="member-id">
                        {member.gender === "male"
                          ? "M"
                          : member.gender === "female"
                            ? "F"
                            : ""}
                      </span>
                      <span className="member-id">HS{member.user_id}</span>
                    </div>

                    <div className="member-details" >
                      <div className="detail-row">
                        <span className="detail-label">Age:</span>
                        <span className="detail-value">
                          {calculateAge(member.dob)} Yrs
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Height:</span>
                        <span className="detail-value">
                          {formatHeight(member.height)}
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Gender:</span>
                        <span className="detail-value">
                          {member.gender}
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Caste:</span>
                        <span className="detail-value">
                          {member.caste || "N/A"}
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Location:</span>
                        <span className="detail-value">
                          {member.curr_location || member.country || "India"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            )) : ("")}

          </div>
        </Modal.Body>
      </Modal>

    </>
  );
}
